









import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../system/mixins";
import { DocumentStructureEditableMixin } from "../../../mixins";

@Component
export default class EditorMenu extends Mixins(ModelEditableMixin, DocumentStructureEditableMixin) {
  get isEditing(): boolean {
    return !!this.lastFocusedItem;
  }

  get isRemovable(): boolean {
    return this.isEditing
      && this.isItemRemovable(this.lastFocusedItem);
  }

  get removeDesctiption(): string {
    return (!this.isEditing
      ? "現在は選択されていません。"
      : (!this.isRemovable
        ? "現在選択されてるオブジェクトは削除できません。"
        : ""));
  }

  onRemoveButtonClicked(): void {
    this.removeItem(this.lastFocusedItem);
  }
}
